import { BaseFeature } from '@core/shared/feature';
import { MEMBERSHIP_PLUGINS_TOKEN } from '@common/membership/shared';
export class MembershipPluginsInsuranceBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@pflegetheke/membership-plugins-insurance/feature","featureId":"pflegetheke-membership-plugins-insurance"},
      dependencies: ['common-membership', 'common-health-insurances'],
      abilityActions: false,
      providers: [{
        forPlatform: 'frontend',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'InsuranceSimpleFrontendMembershipPlugin',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'admin',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'InsuranceSimpleFrontendMembershipPlugin',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'backend',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'InsuranceSimpleBackendMembershipPlugin',
        importFrom: 'backend-shared'
      }, {
        forPlatform: 'frontend',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'Insurance2025FrontendMembershipPlugin',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'admin',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'Insurance2025FrontendMembershipPlugin',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'backend',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'Insurance2025BackendMembershipPlugin',
        importFrom: 'backend-shared'
      }, {
        forPlatform: 'frontend',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'PrivateInsuranceSimpleFrontendMembershipPlugin',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'admin',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'PrivateInsuranceSimpleFrontendMembershipPlugin',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'backend',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'PrivateInsuranceSimpleBackendMembershipPlugin',
        importFrom: 'backend-shared'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {}
      }
    };
  }
}